import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  handleListingIdClickFavorite: null,
  saveSearchTrigger: false,
};

export const listingSearch = createSlice({
  name: "stickyInfoBar",
  initialState,
  reducers: {
    handleListingId: (state, action) => {
      state.handleListingIdClickFavorite = action.payload;
    },
    toggleSaveSearchTrigger: (state, action) => {
      state.saveSearchTrigger = action.payload;
    },
  },
});

export const { handleListingId, toggleSaveSearchTrigger } = listingSearch.actions;

export default listingSearch.reducer;
